//@flow
import * as actionTypes from './actionTypes';
import {
    submitTaskApi,getTaskApi,getCustomersApi,getLineItemsApi,createLineItemApi,updateLineItemApi,
    moveDownLineItemApi,moveUpLineItemApi,deleteLineItemApi
} from '../../apiUtils/api';
import { transformDataToEditFormData } from './editFormData'
import { getReviewOutcome } from '../demeter/submitFormData'
import type { Dispatch$Type,ReducerState$Type,EditForm$Type,PostForm$Type } from '../genericFlowTypes'

const workflowType = 'Nemesis'

export const getTaskData=(nemesis:ReducerState$Type, jwt:string,taskAcceptedInfoId: number)=>{
    return (dispatch:Dispatch$Type) => getTaskApi(jwt,workflowType,taskAcceptedInfoId.toString())
    .then((res)=>res.json()).then((data)=>{
        const error = (data.error:any|null)
        if (error){
            dispatch({type: actionTypes.NEMESIS_EDIT_VERIFY_FORM_DATA_ERROR,error: error});
        }else {
            const formData = transformDataToEditFormData(data,nemesis)
            dispatch({
                type: actionTypes.NEMESIS_EDIT_VERIFY_FORM_DATA_SUCCESS, 
                formData: formData,reviewQuestions: data['reviewQuestions'] });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.NEMESIS_EDIT_VERIFY_FORM_DATA_ERROR, error: err});
    })
}

export const invoiceSubmissionCompleted = () => {
    return { type: actionTypes.NEMESIS_INV_SUBMITTED_COMPLETED };
}

export const invoiceSubmission = (jwt:any,taskAcceptedInfoId:number,nemesisResultset:any,nemesis:ReducerState$Type)=>{
    let payload:PostForm$Type={
        taskAcceptedInfoId:taskAcceptedInfoId
    };

    if (nemesisResultset.isInvalidDoc){
        payload.isInvalidDoc=true;
    }else {
        payload.customerName=nemesisResultset.customerName;
        payload.poNo=nemesisResultset.poNo;
        payload.poDate=nemesisResultset.poDate;
        payload.serviceAddr=nemesisResultset.serviceAddr;
        payload.total=nemesisResultset.total;
        payload.isInvalidDoc=nemesisResultset.isInvalidDoc?nemesisResultset.isInvalidDoc:false;
        payload.isOverrideTotal=nemesisResultset.isOverrideTotal?nemesisResultset.isOverrideTotal:false;
        payload.isOverrideCustomerName=nemesisResultset.isOverrideCustomerName?nemesisResultset.isOverrideCustomerName:false;
    }

    if (nemesis.reviewQuestions && nemesis.reviewQuestions.length > 0){
        payload.reviewOutcome=getReviewOutcome(nemesisResultset,nemesis.reviewQuestions)
    }
    
    return (dispatch:Dispatch$Type) => submitTaskApi(jwt,payload).then((res)=>res.json()).then((data) =>{
        if (data['error']){
            dispatch({type: actionTypes.NEMESIS_INV_SUBMIT_ERROR, error: data.error});
        }else {
            dispatch({type: actionTypes.NEMESIS_INV_SUBMIT_SUCCESS});
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.NEMESIS_INV_SUBMIT_ERROR, error: err});
    })
}

export const updateFormError=(error:any|null)=>{
    return { type: actionTypes.NEMESIS_UPDATE_FORM_ERROR, formError: error }
}

export const populateCustomersList=(jwt:any)=>{
    return (dispatch:Dispatch$Type) => getCustomersApi(jwt,workflowType).then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.REFRESH_NEMESIS_CUSTOMERS_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.REFRESH_NEMESIS_CUSTOMERS_SUCCESS, customers: data.customers });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.REFRESH_NEMESIS_CUSTOMERS_ERROR, error: err});
    })
}

export const getLineItems=(jwt:any,page:number,pageSize:number,sortField:string,sortOrder:any,taskAcceptedInfoId:number)=>{
    return (dispatch:Dispatch$Type) => getLineItemsApi(jwt,workflowType,page,pageSize,sortField,sortOrder,taskAcceptedInfoId)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.GET_NEMESIS_ITEMS_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.GET_NEMESIS_ITEMS_SUCCESS, data: data });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.GET_NEMESIS_ITEMS_ERROR,error: err});
    })
}

export const setPage=(jwt:any,nemesis:ReducerState$Type,page:number)=>{
    return getLineItems(jwt,page,(nemesis.pageSize:any),(nemesis.sortField:any),nemesis.sortOrder,(nemesis.taskAcceptedInfoId:any));
}

export const setPageSize=(jwt:any,nemesis:ReducerState$Type,pageSize:number)=>{
    return getLineItems(jwt,(nemesis.page:any),pageSize,(nemesis.sortField:any),nemesis.sortOrder,(nemesis.taskAcceptedInfoId:any));
}

export const sortData=(jwt:any,nemesis:ReducerState$Type,sortField:any,sortOrder:any)=>{
    return getLineItems(jwt,(nemesis.page:any),(nemesis.pageSize:any),sortField,sortOrder,(nemesis.taskAcceptedInfoId:any));
}

export const createNewLineItem=(jwt:any,newLineItem:any,taskAcceptedInfoId:number)=>{
    return (dispatch:Dispatch$Type) => createLineItemApi(jwt,workflowType,newLineItem,taskAcceptedInfoId)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.CREATE_NEW_NEMESIS_ITEM_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.CREATE_NEW_NEMESIS_ITEM_SUCCESS, data: data });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.CREATE_NEW_NEMESIS_ITEM_ERROR,error: err});
    })
}

export const editLineItem=(lineItem:any)=>{
    let convertToFormObj={};
    convertToFormObj.id=lineItem.id;
    convertToFormObj.itemDesc=lineItem.item_desc;
    convertToFormObj.itemCustomerPartId=lineItem.item_customer_part_id;
    convertToFormObj.itemQty=lineItem.item_qty;
    convertToFormObj.itemPrice=lineItem.item_price;
    convertToFormObj.itemTotal=lineItem.item_total;
    convertToFormObj.isOverrideNaItemQty=lineItem.is_override_na_item_qty;
    convertToFormObj.isOverrideNaItemPrice=lineItem.is_override_na_item_price;
    convertToFormObj.isOverrideItemTotal=lineItem.is_override_item_total;
    
    return { type: actionTypes.EDIT_NEMESIS_ITEM, lineItem: convertToFormObj };
}

export const updateLineItem=(jwt:any,updateLineItem:any,id:number)=>{
    return (dispatch:Dispatch$Type) => updateLineItemApi(jwt,workflowType,updateLineItem,id)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.UPDATE_NEMESIS_ITEM_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.UPDATE_NEMESIS_ITEM_SUCCESS });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.UPDATE_NEMESIS_ITEM_ERROR,error: err});
    })
}

export const moveDownLineItem=(jwt:any,id:number)=>{
    return (dispatch:Dispatch$Type) => moveDownLineItemApi(jwt,workflowType,id)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.MOVE_DOWN_NEMESIS_ITEM_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.MOVE_DOWN_NEMESIS_ITEM_SUCCESS });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.MOVE_DOWN_NEMESIS_ITEM_ERROR,error: err});
    })
}

export const moveUpLineItem=(jwt:any,id:number)=>{
    return (dispatch:Dispatch$Type) => moveUpLineItemApi(jwt,workflowType,id)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.MOVE_UP_NEMESIS_ITEM_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.MOVE_UP_NEMESIS_ITEM_SUCCESS });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.MOVE_UP_NEMESIS_ITEM_ERROR,error: err});
    })
}

export const deleteLineItem=(jwt:any,id:number)=>{
    return (dispatch:Dispatch$Type) => deleteLineItemApi(jwt,workflowType,id)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.DELETE_NEMESIS_ITEM_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.DELETE_NEMESIS_ITEM_SUCCESS });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.DELETE_NEMESIS_ITEM_ERROR,error: err});
    })
}

export const openAddEditLineItemForm=()=>{
    return { type: actionTypes.OPEN_ADD_EDIT_LINEITEM_FORM };
}

export const lineItemSelectedId=(id:number)=>{
    return { type: actionTypes.SELECTED_NEMESIS_ITEM_ID, lineItemId: id}
}

export const cancelAddEditLineItemForm=()=>{
    return { type: actionTypes.CANCEL_ADD_EDIT_LINEITEN_FORM };
}


// WEBPACK FOOTER //
// ./src/redux/nemesis/actions.js